import { render, staticRenderFns } from "./EditCamera.vue?vue&type=template&id=31874034"
import script from "./EditCamera.vue?vue&type=script&lang=js"
export * from "./EditCamera.vue?vue&type=script&lang=js"
import style0 from "./EditCamera.vue?vue&type=style&index=0&id=31874034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports